export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";